import { render } from "./ClassroomLab.vue?vue&type=template&id=512178e3"
import script from "./ClassroomLab.vue?vue&type=script&lang=js"
export * from "./ClassroomLab.vue?vue&type=script&lang=js"
script.render = render

export default script